<template>
  <sidebar-right
    @overlayClicked="outside"
    :class="[
      'navbar-collapse offcanvas-collapse offcanvas-collapse--right offcanvas-collapse--720',
      { open: show }
    ]"
  >
  <div class="bg-white md__card--holder">
    <div class="card">
      <!-- Card header -->
      <div class="card-header" :class="{
            'blue-class': $route.name == 'projects',
            'green-class': $route.name == 'tasks.home',
            'yellow-class': $route.name == 'timesheet.home'
          }">
        <!-- Title -->
        <h4 class="h3 mb-0">{{ editTitle }}</h4>
      </div>
      <!-- Card Body -->
      <div class="card-body">
        <form class="hideBlockParent">
          <div class="form-group mb-4">
            <label>Name</label>
            <input
              id="exampleFormControlInput1"
              type="text"
              class="form-control"
              v-model="task.name"
              placeholder="Task Name"
            />
          </div>
          <div class="form-group mb-4">
            <label>Description</label>
            <html-editor v-model="task.description" value />
          </div>


          <div class="row mx-0 mb-4 mt-4">
            <div class="col ml-0 px-0">
              <h4 class="h3 mb-0">Quote</h4>
            </div>
            <div class="col-auto px-0">
              <label class="custom-toggle">
                <input
                  type="checkbox"
                  data-toggle="collapse"
                  id="checkQuote"
                  v-model="task.has_quote"
                  data-target="#quote"
                  aria-expanded="false"
                />
                <span
                  class="custom-toggle-slider rounded-circle"
                  data-label-off="OFF"
                  data-label-on="ON"
                ></span>
              </label>
            </div>
          </div>
          <div class="mb-4" id="hiddenParrent" v-if="task.has_quote">
            <div class="w-100 collapse show tabToggle" id="quote">
              <ul class="nav tabPanel mb-3" role="tablist">
                <li class="mr-5" v-for="(res, ind) in resources" :key="ind">
                  <!-- <base-radio v-model="selectedResource" :name="res" class="mb-3" @click="onResourceChanged" >{{ res.name }}</base-radio> -->

                  <div class="custom-control custom-radio">
                    <input
                      :id="ind"
                      name="resource"
                      v-model="task.resource"
                      :value="res"
                      class="custom-control-input"
                      type="radio"
                      @change="onResourceChanged"
                    />
                    <label :for="ind" class="custom-control-label">
                      {{ res.name }}
                    </label>
                  </div>
                </li>
              </ul>
              <div class="tab-content">
                <div
                  class="tab-pane fade active show"
                  id="rate"
                  role="tabpanel"
                >
                  <div class="px-0">
                    <div class="form-row">
                      <label class="col-md-12">Rate & Hours</label>
                      <div class="col-md-6">
                        <div class="form-group">
                          <input
                            type="text"
                            v-model="task.hourly_cost"
                            placeholder="Rate"
                            class="form-control"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <input
                            v-model="task.quoted_hours"
                            type="text"
                            placeholder="Hour(s)"
                            class="form-control"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group mb-4">
            <label>Month(s)</label>
            <input
              type="text"
              v-model="task.months"
              class="form-control"
              name="month"
              placeholder="Number of Month"
            />
          </div>
          <div class="form-group mb-4">
            <!-- <label>Deadline</label>
          <div class="input-group input-group-alternative">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="ni ni-calendar-grid-58"></i>
              </span>
            </div>
            <input
              class="form-control datepicker"
              placeholder="Select date"
              type="text"
              v-model="deadline"
            />
          </div>-->
            <base-input
              alternative
              prepend-icon="ni ni-calendar-grid-58"
              label="Deadline"
            >
              <flat-picker
                slot-scope="{ focus, blur }"
                @on-open="focus"
                @on-close="blur"
                :config="{ allowInput: true }"
                class="form-control datepicker"
                v-model="task.deadline"
              ></flat-picker>
            </base-input>
          </div>

          <base-button
            type="primary"
            class="my-4 btn-block"
            @click="handleSubmit"
            >{{ editId ? "Update" : "Create" }}</base-button
          >
        </form>
      </div>
    </div>
  </div>
</sidebar-right>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import { required, minLength, between, email } from "vuelidate/lib/validators";
import HtmlEditor from "@/components/Inputs/HtmlEditor";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import UserPicker from "@/app/components/UserPicker.vue";
import SidebarRight from "../layout/SidebarRight.vue";
export default {
  name: "CreateAssetTask",
  props: ["editId", "show", "fullWidth", "project"],
  data() {
    return {
      task: {
        asset_users: []
      },
      
      
      editTitle: "New Requirement"
    };
  },
  components: {
    HtmlEditor,
    flatPicker,
    UserPicker,
    SidebarRight
  },
  validations: {
    projectTitle: {
      required,
      minLength: minLength(4)
    },
    projectType: {
      required
    },
    client: {
      required
    }
  },

  watch: {
    editId(newVal, oldVal) {
      console.log(oldVal, newVal, "9++++++++++");
      let role = this.roles.filter(r => r.name == "CREATOR")[0];
      let assigner = { ...this.profile };
      // if (newVal != oldVal) {
      //   if (newVal) {
      //     this.editTitle = "Edit Task";
      //     this.fetchTask(newVal);
      //   } else {
      //     this.task = {assignedBy: { user: assigner, asset_role: role }};
      //     this.editTitle = "New Task";
      //   }
      // } else {
      //   this.task = {assignedBy: { user: assigner, asset_role: role }};
      //   this.editTitle = "New Task";
      // }
    }
  },

  computed: {
    ...mapState("user", ["profile"]),
    ...mapState("common", ["roles", "resources"])
  },

  async mounted() {
    console.log("mounted+++++++");
    // console.log(this.$router, this.$route, "ddddd")
    $('[data-toggle="tooltip"]').tooltipster({
      theme: "tooltipster-borderless"
    });
    await this.fetchRoles();
    await this.fetchResources()
    if (!this.editId) {
      //this.editTitle = "New Task";
      let role = this.roles.filter(r => r.name == "CREATOR")[0];
      let owner = { ...this.profile };
      this.task = {
        assignedBy: { user: owner, asset_role: role }
      };
    } else {
      //this.editTitle = "Edit Task";
      this.fetchTask(this.editId);
    }
  },

  methods: {
    ...mapActions("user", ["fetchAllUsers"]),
    ...mapActions("task", ["fetchSingleTask", "createTask", "updateTask"]),
    ...mapActions("common", ["fetchRoles", "fetchResources"]),
    ...mapMutations(["setGanttRender"]),
    onResourceChanged() {
      this.task.hourly_cost = this.task.resource.hourly_cost;
    },
    async fetchTask(val) {
      try {
        const res = await this.fetchSingleTask(val);
        this.task = res.data || {};
      } catch (e) {
        this.task= {}
        this.$snack.success("Could not fetch task");
      }
    },

    outside() {
      this.$emit("outSideClicked");
    },

    handleSubmit() {
      if (this.task.name == null || this.task.name == "") {
        this.$snack.success("Task title is required");
        return;
      }

      if (this.task.description == null || this.task.description == "") {
        this.$snack.success("Description is required");
        return;
      }

      if (!this.task.assignedBy) {
        this.$snack.success("Task From is required");
        return;
      }

      if (!this.task.assignedTo) {
        this.$snack.success("Task To is required");
        return;
      }

      // add task by and task to validations

      if (this.task.months == null || this.task.months == "") {
        this.$snack.success("Months is required");
        return;
      }

      if (this.task.deadline == null || this.task.deadline == "") {
        this.$snack.success("Deadline is required");
        return;
      }

      if (this.task.resource) {
        if (this.task.hourly_cost == null || this.task.hourly_cost == "") {
          this.$snack.success("Please enter total rate");
          return;
        }

        if (this.task.quoted_hours == null || this.task.quoted_hours == "") {
          this.$snack.success("Please enter total hours");
          return;
        }
      } else {
        this.$snack.success("Select price resource");
      }

      let body = {
        ...this.task,
        project_id: this.$route.params.id
      };

      if (this.editId != undefined) {
        body.id = this.editId;
        this.updateTask(body)
          .then(res => {
            this.setGanttRender();
            this.$snack.success("Task Updated Successfully");
            this.$emit("taskCreated");
            this.selectedUser = null;
          })
          .catch(er => {
            this.$snack.success("Could not create project");
          });
      } else {
        this.createTask(body)
          .then(res => {
            this.setGanttRender();
            this.$snack.success("Project Created Successfully");
            this.$emit("taskCreated");
            this.selectedUser = null;
          })
          .catch(er => {
            this.$snack.success("Could not create project");
          });
      }
    }
  },

 
};
</script>

<style lang="sass"></style>
